import Carousel from '../components/Carousel';
import { imagePaths } from '../content/images/imagePaths';
import Footer from '../components/Footer';
import MassesTile from '../components/tiles/MassesTile';
import VideoTile from '../components/tiles/VideoTile';
import NewsWithImageTile from '../components/tiles/NewsWithImageTile';

const MainPage = () => {
    const { homePagePhotos } = imagePaths();
    
    return (
        <div className="d-flex flex-column min-vh-100 bg-gradient">
          <Carousel images={homePagePhotos} />

          <VideoTile 
            text='K příležitosti Slavnosti Zmrtvýchvstání Páně farní sbor zazpíval Velikonoční mši od Ladislava Němce. Zaposlouchat se do zvuků této Velikonoční mše můžete i vy na tomto záznamu z 20. dubna 2025.'
            title='Velikonoční mše Ladislava Němce'
            videoTitle='Velikonoční mše Ladislava Němce'
            videoUrl='https://www.youtube.com/embed/dqVR7scqnFQ?si=oWR88pIdQaxKiEQR' />

          <MassesTile />

          <Footer />
      </div>
    );
  };

  export default MainPage;